export function transformBrand(codeVendeur: string): string {
  switch (codeVendeur.toUpperCase()) {
    case 'VYV':
      return 'VY';
    case 'HM':
      return 'HM';
    case 'MGEN':
      return 'MG';
    case 'MNT':
      return 'MT';
    default:
      return codeVendeur.toUpperCase();
  }
}

export const HmBrand = 'HM';
export const MgenBrand = 'MG';
export const MntBrand = 'MT';

export function isPartner(brand: any): boolean {
  let brandNormalise = transformBrand(brand);
  return brandNormalise === HmBrand || brandNormalise === MgenBrand || brandNormalise === MntBrand;
}
